import { useEffect, useState } from "react";

export default function MoneyInput({ value, onSave, testId, suffix }) {
  const [val, setVal] = useState(value || 0);
  useEffect(() => setVal(value || 0), [value]);

  const commit = () => {
    const n = Number(val) || 0;
    if (n !== (value || 0)) onSave(n);
  };

  return (
    <div className="flex items-center gap-1">
      <span className="text-slate-500 text-xs">$</span>
      <input
        data-testid={testId}
        type="number"
        min="0"
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
        className="w-24 bg-black/30 border border-white/10 rounded-md px-2 py-1 text-sm text-white font-mono-tech focus:outline-none focus:border-[#4690d9]"
      />
      {suffix && <span className="text-slate-500 text-xs">{suffix}</span>}
    </div>
  );
}
